<script setup lang="ts">

    const props = defineProps({
        class: {
            type: String,
            defaultValue: ''
        },
        type: {
            type: String as PropType<'1' | '2' | '3' | '4' | '5' | '6' | '7'>,
            defaultValue: '1',
            required: true
        },
    })

    const classObject = computed(() => ({
        'leading-[1.5] text-[4.8rem] font-bold max-md:text-[3.2rem]': props.type == '1',
        'leading-[1.5] text-[3.2rem] font-bold max-md:text-[2.4rem]' : props.type == '2',
        'leading-[1.5] text-[3rem] font-bold' : props.type == '3',
        'leading-[1.5] text-[2.4rem] font-bold max-md:text-[1.8rem]' : props.type == '4',
        'leading-[1.5] text-[2rem] font-bold max-md:text-[1.8rem]' : props.type == '5',
        'leading-[1.5] text-[1.8rem] font-bold max-md:text-[1.6rem]' : props.type == '6',
        'leading-[1.5] text-[1.6rem] font-bold max-md:text-[1.4rem]' : props.type == '7',
    }))

</script>

<template>
    <p class="font-inter" :class="[classObject, props.class]">
        <slot />
    </p>
</template>